import { create } from 'zustand'

import { findCountCardApi, findCountOrderApi } from '@/network/api/global'
import { unwrapModelPayload } from '@/network/api/model/unwrap'
import { getAccessToken } from '@/utils/authToken'

interface MallCountStore {
  cartCountInfo: Record<string, any>
  orderCountInfo: Record<string, any>
  getCartCountInfo: () => Promise<void>
  getOrderCountInfo: () => Promise<void>
}

export const useMallCountStore = create<MallCountStore>((set) => ({
  cartCountInfo: {},
  orderCountInfo: {},
  getCartCountInfo: async () => {
    if (!getAccessToken()) {
      set(() => ({ cartCountInfo: {} }))
      return
    }
    try {
      const res = await findCountCardApi()
      const payload = unwrapModelPayload<Record<string, any>>(res)
      if (payload) {
        set(() => ({ cartCountInfo: payload }))
      }
    } catch (error) {
      console.error('getCartCountInfo failed', error)
    }
  },
  getOrderCountInfo: async () => {
    if (!getAccessToken()) {
      set(() => ({ orderCountInfo: {} }))
      return
    }
    try {
      const res = await findCountOrderApi()
      const payload = unwrapModelPayload<Record<string, any>>(res)
      if (payload) {
        set(() => ({ orderCountInfo: payload }))
      }
    } catch (error) {
      console.error('getOrderCountInfo failed', error)
    }
  },
}))
